import Head from "next/head";

import { MEDIA_BASE_URL } from "@/utils/api";

const SeoHead = ({ meta_title = null, meta_description = null, meta_keywords = null, canonical_url = null, og_title = null, og_description = null, og_image = null, twitter_title = null, twitter_description = null, twitter_image = null, robots = null, slug = null }) => {
  // const siteUrl = "simpolo.com"; // Change to your actual domain
  const siteUrl = "https://simpolo.com"; // Change to your actual domain
  const pageUrl = slug ? `${siteUrl}/${slug}` : siteUrl;
  const defaultImage = `${siteUrl}/banner/home01.jpg`; // Replace with actual fallback image

  return (
    <Head>
      {/* Title & Meta Description */}
      <title>{meta_title}</title>
      <meta name="description" content={meta_description} />
      {meta_keywords && <meta name="keywords" content={meta_keywords} />}

      {/* Robots Meta */}
      {robots && <meta name="robots" content={robots} />}

      {/* Open Graph (OG) */}
      <meta property="og:title" content={og_title || meta_title} />
      <meta property="og:description" content={og_description || meta_description} />
      <meta property="og:image" content={og_image ? `${MEDIA_BASE_URL}${og_image}` : defaultImage} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />

      {/* Twitter Meta */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={twitter_title || meta_title} />
      <meta name="twitter:description" content={twitter_description || meta_description} />
      <meta name="twitter:image" content={twitter_image ? `${MEDIA_BASE_URL}/${twitter_image}` : defaultImage} />

      {/* Canonical URL */}
      {/* {canonical_url && <link rel="canonical" href={canonical_url} />} */}
    </Head>
  );
};

export default SeoHead;
